/**
 * @desc 导出线下销售订单列表
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(params: API.business.customerOrder.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
